import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	dataCenterCardHeading: {
		id: 'fastshift.summary.data-center-card.heading',
		defaultMessage: 'Data Center instances assessed',
		description: 'Heading for the Data Center summary card',
	},
	areaImprovementCardHeading: {
		id: 'fastshift.summary.area-improvement-card.heading',
		defaultMessage: 'Areas to improve',
		description: 'Heading for the area improvement summary card',
	},
	migrationCompletedCardHeading: {
		id: 'fastshift.summary.migration-completed-card.heading',
		defaultMessage: 'Migrations completed',
		description: 'Heading for the migration completed summary card',
	},
	migrationInProgressCardHeading: {
		id: 'fastshift.summary.migration-running-card.heading',
		defaultMessage: 'Migrations in progress',
		description: 'Heading for the migration in progress summary card',
	},
	unsuccessfulMigrationCardHeading: {
		id: 'fastshift.summary.unsuccessful-migration-card.heading',
		defaultMessage: 'Unsuccessful migrations',
		description: 'Heading for the unsuccessful migration summary card',
	},
	errorDescription: {
		id: 'fastshift.summary.organization-summary.error-description',
		defaultMessage: 'We’re unable to retrieve the data about your organization summary.',
		description: 'Description for the error message in the organization summary',
	},
	refresh: {
		id: 'fastshift.summary.organization-summary.refresh',
		defaultMessage: 'Refresh',
		description: 'Button text to refresh the organization summary',
	},
	organizationSummaryTitle: {
		id: 'fastshift.summary.organization-summary.title',
		defaultMessage: 'Organization summary',
		description: 'Title for the organization summary',
	},
});
